import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import IndexRoute from './routes/index.routes';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <IndexRoute />
    </React.StrictMode>
);
